import { render } from "./EditingMediafiles.vue?vue&type=template&id=373c0040"
import script from "./EditingMediafiles.vue?vue&type=script&lang=js"
export * from "./EditingMediafiles.vue?vue&type=script&lang=js"
script.render = render

export default script